import React from 'react';
import { Route, Routes, BrowserRouter} from 'react-router-dom';
import { NAVIGATE_TO_HOME } from './constants/routeConstant';
import Home from './components/home/Home';

export default function App() {

  return (
    <BrowserRouter>
      <Routes>
        {/* Open Routes */}
        <Route
          path={NAVIGATE_TO_HOME}
          element={<Home />}
        />
      </Routes>
    </BrowserRouter>
  );
}
